// Render only the persisted response distribution, including fractional scale values.
export function breakdown(s, lang) {
  const labels = [s.labels[lang], s.labels.en, s.labels.th].find(list => Array.isArray(list) && list.length) || [];
  const keys = Object.keys(s.counts || {}).map(Number).filter(Number.isFinite);
  const indexes = s.type === 'Scale'
    ? Array.from(new Set([...Array.from({ length: 11 }, (_, n) => n), ...keys])).sort((a, b) => a - b)
    : Array.from({ length: Math.max(labels.length, ...keys.map(n => n + 1), 0) }, (_, n) => n);
  return indexes.map(index => ({ label: s.type === 'Scale' ? String(index) : labels[index] || String(index + 1),
    count: s.counts[String(index)] || 0,
    percent: Math.round((s.counts[String(index)] || 0) * 100 / s.total) }));
}
